import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import LocaleService from 'mt-react-common/modules/locale/services/LocaleService';
import SearchAjaxSelect from '../../../Common/Inputs/SearchAjaxSelect';

class LocationSearchAjaxSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectArrItems: [],
      ajaxInProcessed: false
    };
  }

  search = async searchString => {
    this.setState({ ajaxInProcessed: true });
    const result = await LocaleService.getCitiesByName({}, searchString);
    const list = _.map(result.restructureData, item => ({
      value: item.id,
      title: item.locale,
      timeZone: item.timeZone
    }));
    this.setState({ selectArrItems: list, ajaxInProcessed: false });
  };

  render() {
    return (
      <React.Fragment>
        <SearchAjaxSelect
          {...this.props}
          ajaxInProcessed={this.state.ajaxInProcessed}
          selectArrItems={this.state.selectArrItems}
          handleReloadSelectOptions={value => this.search(value)}
        />
      </React.Fragment>
    );
  }
}

LocationSearchAjaxSelect.defaultProps = {
  selectTitleNullValue: 'Не выбрано',
  placeholder: null
};

LocationSearchAjaxSelect.propTypes = {
  // IN PROPS
  placeholder: PropTypes.string,
  handleChangeValue: PropTypes.func.isRequired
};

export default LocationSearchAjaxSelect;



// WEBPACK FOOTER //
// ./src/components/UserAccount/UserAnketaForm/inputs/LocationSearchAjaxSelect.js